import React, { useEffect, useRef, useState } from 'react';
import './CustomNavbar.scss';
import { Menu, MenuItem, Sidebar } from 'react-pro-sidebar';
import { NavigateTo } from '../../Utilities';
import { FaBars } from 'react-icons/fa';
import { IoIosCloseCircle } from 'react-icons/io';
import { pages } from '../../Constants';

export default function CustomNavbar() {
  const [toggled, setToggled] = useState(false);

  function handleNavigate(event: Event, page: string) {
    if (window.location.pathname !== `${page}`) {
      NavigateTo(event, page)
    } else {
      setToggled(!toggled)
    }
  }

  let menuRef: any = useRef();

  useEffect(() => {
    let handler = (e: any) => {
      if (menuRef.current.contains(e.target)) {
        setToggled(!toggled);
      }
    };
    document.addEventListener("click", handler);
    return () => {
      document.removeEventListener("click", handler);
    }

  });
  return (
    <div style={{ display: 'flex', height: '100%', justifyContent: 'end', }}>
      <div className='icon-container'>
        {toggled ? <IoIosCloseCircle size={"2.5em"} color={"var(--secondary-color)"} onClick={() => setToggled(!toggled)} className='sb-button' /> : <FaBars size={"1.5em"} color={"var(--secondary-color)"} onClick={() => setToggled(!toggled)} className='sb-button' />}
      </div>
      <Sidebar className="sidebar" onBackdropClick={() => setToggled(true)} toggled={toggled} breakPoint="all" rtl ref={menuRef}>
        <Menu className='menu'  >
          {pages.map((pageInfo, index) => {
            return (
              pageInfo.isNavBarComponent && <MenuItem key={index} active={window.location.pathname === `${pageInfo.url}`} className='menu-item' onClick={(e: any) => { handleNavigate(e, pageInfo.url) }}>{pageInfo.name}</MenuItem>
            )
          })}
        </Menu>
      </Sidebar>

    </div>
  );
};
